export const currentDate = () => {
    const currDate = new Date();
    const date = currDate.getDate();
    const month = currDate.getMonth() + 1;
    const year = currDate.getFullYear();

   return `${date < 10 ? `0${date}` : `${date}`}/${month < 10 ? `0${month}` : `${month}`}/${year}`
};

export const currentDateLocale = () => new Date().toLocaleString() + "";

export const dateAsLocaleString = (date) => date.toLocaleString() + "";

export const dateAsYYYYMM = (date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return year.toString() + month.toString().padStart(2, '0');

}

export const dateAsYYMM = (date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return year.toString().substr(-2) + month.toString().padStart(2, '0');

}

